// Mock data for RELAX & RIDE Taxi Service

export const bookings = [
  {
    id: '1',
    name: 'John Smith',
    email: 'john@example.com',
    phone: '+1242-555-0123',
    service: 'Airport Transfer',
    pickupLocation: 'Nassau Airport',
    dropoffLocation: 'Atlantis Paradise Island',
    date: '2025-01-15',
    time: '14:30',
    passengers: 2,
    status: 'confirmed',
    assignedDriver: 'driver1'
  },
  {
    id: '2',
    name: 'Maria Garcia',
    email: 'maria.g@example.com',
    phone: '+1242-555-0456',
    service: 'Island Tour',
    pickupLocation: 'Baha Mar Resort',
    dropoffLocation: 'Various scenic locations',
    date: '2025-01-16',
    time: '09:00',
    passengers: 4,
    status: 'pending',
    assignedDriver: 'driver1'
  },
  {
    id: '3',
    name: 'Robert Johnson',
    email: 'rjohnson@corporate.com',
    phone: '+1242-555-0789',
    service: 'Corporate Transportation',
    pickupLocation: 'Downtown Nassau',
    dropoffLocation: 'British Colonial Hotel',
    date: '2025-01-15',
    time: '16:00',
    passengers: 1,
    status: 'in-progress',
    assignedDriver: 'driver1'
  },
  {
    id: '4',
    name: 'Lisa Anderson',
    email: 'lisa.a@example.com',
    phone: '+1242-555-0321',
    service: 'Airport Transfer',
    pickupLocation: 'Cable Beach Resort',
    dropoffLocation: 'Nassau Airport',
    date: '2025-01-17',
    time: '11:30',
    passengers: 3,
    status: 'confirmed',
    assignedDriver: 'driver1'
  },
  {
    id: '5',
    name: 'David Williams',
    email: 'dwilliams@example.com',
    phone: '+1242-555-0999',
    service: 'Airport Transfer',
    pickupLocation: 'Nassau Airport',
    dropoffLocation: 'Paradise Island',
    date: '2025-01-15',
    time: '10:00',
    passengers: 2,
    status: 'pending',
    assignedDriver: 'rastario'
  },
  {
    id: '6',
    name: 'Jennifer Brown',
    email: 'jbrown@example.com',
    phone: '+1242-555-0888',
    service: 'Island Tour',
    pickupLocation: 'Atlantis Resort',
    dropoffLocation: 'Blue Lagoon Island',
    date: '2025-01-16',
    time: '13:00',
    passengers: 5,
    status: 'confirmed',
    assignedDriver: 'rastario'
  },
  {
    id: '7',
    name: 'Michael Davis',
    email: 'mdavis@business.com',
    phone: '+1242-555-0777',
    service: 'Corporate Transportation',
    pickupLocation: 'Hilton Hotel',
    dropoffLocation: 'Government House',
    date: '2025-01-15',
    time: '08:30',
    passengers: 1,
    status: 'in-progress',
    assignedDriver: 'rastario'
  }
];

export const services = [
  {
    id: '1',
    title: 'Airport Transfers',
    description: 'Reliable and comfortable transportation to and from Nassau International Airport. We monitor flight times to ensure prompt pickups.',
    features: ['Meet & Greet Service', 'Flight Monitoring', 'Luggage Assistance', '24/7 Availability'],
    icon: 'plane'
  },
  {
    id: '2',
    title: 'Island Tours',
    description: 'Discover the beauty of The Bahamas with our customized island tours. Visit pristine beaches, historic sites, and local attractions.',
    features: ['Customizable Routes', 'Local Expert Drivers', 'Flexible Duration', 'Photo Stops'],
    icon: 'palm-tree'
  },
  {
    id: '3',
    title: 'Corporate Transportation',
    description: 'Professional transportation solutions for business travelers and corporate events. Punctual, discrete, and comfortable service.',
    features: ['Professional Drivers', 'Flexible Scheduling', 'Corporate Accounts', 'Invoice Billing'],
    icon: 'briefcase'
  },
  {
    id: '4',
    title: 'Special Events',
    description: 'Make your special occasions memorable with our premium transportation services for weddings, parties, and celebrations.',
    features: ['Event Coordination', 'Multiple Vehicles', 'Decoration Options', 'Special Requests'],
    icon: 'calendar'
  }
];

export const testimonials = [
  {
    id: '1',
    name: 'Sarah Johnson',
    location: 'Miami, FL',
    rating: 5,
    text: 'Excellent service! The driver was waiting for us at the airport and took us safely to our resort. Very professional and friendly.',
    date: '2024-12-10'
  },
  {
    id: '2',
    name: 'Michael Thompson',
    location: 'Toronto, Canada',
    rating: 5,
    text: 'Best taxi service in Nassau! Used them for our island tour and they showed us amazing spots we would have never found on our own.',
    date: '2024-11-28'
  },
  {
    id: '3',
    name: 'Emily Rodriguez',
    location: 'Nassau, Bahamas',
    rating: 5,
    text: 'I use RELAX & RIDE for all my corporate transportation needs. Always on time, professional, and reliable. Highly recommend!',
    date: '2024-12-05'
  }
];

export const faqs = [
  {
    id: '1',
    question: 'How do I book a ride?',
    answer: 'You can book through our online booking system, call us at +1242 525-8765, or email RASRIO777@HOTMAIL.COM. We recommend booking in advance for airport transfers.'
  },
  {
    id: '2',
    question: 'Do you offer 24/7 service?',
    answer: 'Yes! We provide round-the-clock service, including late-night airport pickups and early morning transfers.'
  },
  {
    id: '3',
    question: 'What is your cancellation policy?',
    answer: 'Cancellations made 24 hours or more before your scheduled pickup are FREE. However, cancellations made less than 24 hours before pickup time will incur a $25 USD cancellation fee.'
  },
  {
    id: '4',
    question: 'What if I\'m late for my pickup?',
    answer: 'We understand delays happen, but to maintain our schedule for all customers, a late fee of $5 USD per 10 minutes applies if you are not ready at the scheduled pickup time. Please be ready on time to avoid additional charges.'
  },
  {
    id: '5',
    question: 'What areas do you cover?',
    answer: 'We serve all areas of Nassau and Paradise Island, including the airport, hotels, resorts, cruise port, and popular tourist attractions.'
  },
  {
    id: '6',
    question: 'What payment methods do you accept?',
    answer: 'We accept cash (BSD and USD), credit cards, and can arrange corporate billing for business accounts. Payment is due at the time of service.'
  },
  {
    id: '7',
    question: 'How much luggage can I bring?',
    answer: 'Our Honda Step Wagon can accommodate standard luggage for up to 7 passengers. For oversized items or special requirements, please let us know when booking.'
  }
];

export const contactInfo = {
  businessName: 'RELAX & RIDE',
  phone: '+1242-525-8675',
  email: 'rasrio777@hotmail.com',
  location: 'Nassau, The Bahamas',
  hours: '24/7 - Available All Days'
};

export const vehicle = {
  name: 'Honda Step Wagon',
  type: '7-Seater Minivan',
  capacity: 7,
  features: [
    'Spacious 7-Seater Capacity',
    'Air Conditioning',
    'Ample Luggage Space',
    'Comfortable Seating',
    'Clean & Well-Maintained',
    'Perfect for Families & Groups'
  ],
  description: 'Our Honda Step Wagon offers the perfect blend of comfort and space for your journey. Whether you\'re traveling with family or a group, enjoy a smooth ride with room for everyone and their luggage.'
};
